import { Identifier } from "../../id";
export class ModifierTypeId extends Identifier {
    constructor(id) {
        super("ModifierTypeId", id);
    }
}
